import 'core-js/stable';

(function (window, fetch) {
  window.fetchActive = 0;
  const increment = () => window.fetchActive++;
  const decrement = () => window.fetchActive--;
  return function () {
    const request = fetch(...[].slice.apply(arguments, 0));
    increment();
    request.then(decrement, decrement);
    return request;
  };
}(window, fetch));
